import { render } from "./poster-modal.vue?vue&type=template&id=8fcff99a&scoped=true"
import script from "./poster-modal.vue?vue&type=script&lang=js"
export * from "./poster-modal.vue?vue&type=script&lang=js"

import "./poster-modal.vue?vue&type=style&index=0&id=8fcff99a&lang=less&scoped=true"
import "./poster-modal.vue?vue&type=style&index=1&id=8fcff99a&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fcff99a"]])

export default __exports__